(() => {
	document.addEventListener('DOMContentLoaded', () => {

    console.log('accordion js');

		const details = document.querySelectorAll(".c-accordion-wrapper details");

		details.forEach((d) => {
			d.addEventListener("click", () => {
				details.forEach((detail) => {
					if (detail !== d) {
						detail.removeAttribute("open");
					}
				});
			});
		});
	});
})();


// WEBPACK FOOTER //
// ./src/js/block-accordion.js